import {useContext} from "react";
import {ToastContext} from "../Contexts";
import {
    GetPagesForWebsiteResponse, PageFilterRequest, PagesFilterResponse,
    ToastFailureMessage,
} from "../Models/Models";
import HttpRepository from "./HttpRepository";

export function PageService() {
    let {setToast}: any = useContext(ToastContext);

    async function getPages(websiteId: number): Promise<GetPagesForWebsiteResponse> {
        try {
            return (await HttpRepository.getPages(websiteId)).data;
        }
        catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
        }
    }

    async function filterPages(request: PageFilterRequest): Promise<PagesFilterResponse> {
        try {
            return (await HttpRepository.filterPages(request)).data;
        }
        catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
        }
    }

    return {getPages, filterPages}
}